import React, { useState } from 'react';
import { Loading, RadioOrCheckbox } from '@hotmart-org-ca/user-account-ui';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import Request from '@hotmart/request';

import CoinIcon from '@/common/icons/Coin.svg';
import { ENTITY_TYPE } from '@/types';
import { StepCard } from '@/components/step-card';
import { useStepper } from '@/components/stepper';
import { useNotification } from '@/components/notification';

import { useIncome } from '@/common/hooks/query/documents-validations.hooks';
import { formattedIncomeRanges } from '@/pages/home/steps/income/utils';

const entityType: ENTITY_TYPE = ENTITY_TYPE.INDIVIDUAL;

function Income() {
  const { t } = useTranslation();
  const { setError } = useNotification();
  const { onStepClick } = useStepper();
  const [rangeSelected, setRangeSelected] = useState<number>();
  const { data: income, isLoading } = useIncome();
  const ranges = formattedIncomeRanges({ income, entityType });
  const hiddenButton = rangeSelected === undefined;
  const mutation = useMutation({
    mutationFn: (payload: { income?: number }) => {
      return Request('biometric.send.review', payload);
    },
  });

  const handleButtonClick = async () => {
    try {
      await mutation.mutateAsync({ income: rangeSelected });
      onStepClick(3);
    } catch {
      setError('try-again');
    }
  };

  return (
    <StepCard
      icon={CoinIcon}
      title={t(`income.title.${entityType === ENTITY_TYPE.INDIVIDUAL ? 'income' : 'billing'}`)}
      buttonText={t('income.buttonText')}
      onButtonClick={handleButtonClick}
      hiddenButton={hiddenButton}
      customChildren
    >
      <div className="mt-2">
        {isLoading && <Loading />}
        {!isLoading && ranges.map((item, value) => {
          return (
            <RadioOrCheckbox
              type="radio"
              name="income"
              className="mb-5"
              key={`${item}-${value}`}
              id={`${item}-${value}`}
              label={item}
              value={value}
              checked={rangeSelected === value}
              onChange={() => setRangeSelected(value)}
            />
          );
        })}
      </div>
    </StepCard>
  );
}

export default Income;
